import { gql } from '@apollo/client';

export const PracticeSessionFragment = gql`
  fragment PracticeSession on PracticeSession {
    _id
    id: _id
    name
    maxScore
    score
    finished
    createdAt
  }
`;

export const ActivePracticeSessionFragment = gql`
  fragment ActivePracticeSession on ActivePracticeSession {
    ...PracticeSession
    exercisesCount
    currentExerciseIndex
    currentMaxScore
    currentExercise
  }
  ${PracticeSessionFragment}
`;
